import { connect } from 'react-redux';
import { compose } from 'redux';
import { Dispatch } from 'redux-api-middleware';

import { DownloadReportResponse } from '../../../../../store/api/reports/reports.types';
import { downloadReport } from '../../../../../store/api/reports/reportsActions';

import { DownloadButton } from './DownloadButton';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onDownloadReport: (fileName: string) => dispatch<Promise<DownloadReportResponse>>(downloadReport(fileName)),
});

export const DownloadButtonContainer = compose(
  connect(
    undefined,
    mapDispatchToProps,
  ),
)(DownloadButton);
